import styled from 'styled-components'
import { device } from '../Breakpoints'

const AlignCenter = styled.div`
  max-width: 960px;
  margin: auto;
  @media ${device.mobileL} {
    max-width: 100%;
    padding: 0 1em;
    text-align: center;
  }
  div {
    margin-left: -70px;
    padding: 2em 0;
    font-size: 0.8em;
    a,
    span {
      text-decoration: none;
      text-transform: none;
      color: #499490;
    }
    span:last-child a {
      font-weight: bold;
    }
    svg {
      vertical-align: middle;
      padding: 0 0;
      color: #b4dccf;
    }
    @media ${device.laptop} {
      margin-left: 3em;
      font-size: 0.9em;
    }
    @media ${device.mobileL} {
      margin-left: 0px;
      font-size: 0.6em;
    }
  }
`
export default AlignCenter
